import { render } from "./AboutServices.vue?vue&type=template&id=5ed272b6"
import script from "./AboutServices.vue?vue&type=script&lang=js"
export * from "./AboutServices.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspaces\\Portfolio Folder\\pappalaity.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__